import { clientEnvModule } from "@/modules/client-env";
import { electronModule } from "@/modules/electron";
import { logger } from "@/modules/logger";
import { URL } from "url";
import { compactWindowUrlForLogging } from "@/modules/window/compact-url-for-logging";

export const navigateToInternalWindowUrl = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToInternalWindowUrl] Navigating.",
    info: { url: compactWindowUrlForLogging(url), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToInternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.replace(url.toString());
  return;
};

export const navigateToExternalWindowUrl = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToExternalWindowUrl] Navigating.",
    info: { url: compactWindowUrlForLogging(url), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToExternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.replace(url.toString());
  return;
};

/**
 * Opens an external URL while keeping the current page available in browser history.
 *
 * Desktop hands the URL to the operating system, so the current Mem window remains open.
 */
export const navigateToExternalWindowUrlAndPreserveHistory = async ({
  url,
}: {
  url: URL;
}): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToExternalWindowUrlAndPreserveHistory] Navigating.",
    info: { url: compactWindowUrlForLogging(url), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToExternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.assign(url.toString());
};

export const openWindowUrlInNewTab = async ({ url }: { url: URL }): Promise<Window | null> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][openWindowUrlInNewTab] Navigating.",
    info: { url: compactWindowUrlForLogging(url), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToExternalUrl({ url });
    return null;
  }

  // eslint-disable-next-line no-restricted-properties
  const windowProxy = window.open(url.toString(), "_blank");

  return windowProxy;
};

export const navigateToWindowUrlAndRefresh = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToWindowUrlAndRefresh] Navigating.",
    info: { url: compactWindowUrlForLogging(url), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToInternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.assign(url.toString());
};
